import { useEffect } from 'react';

const BASE_URL = 'https://jobmd.md';
const SITE_NAME = 'JobMD';

const defaults = {
  title: 'JobMD - Работа в Молдове',
  description: 'JobMD — платформа для поиска работы в Молдове. Свежие вакансии от прямых работодателей, удобный поиск, фильтры по городу и зарплате.',
  image: '/logo512.png',
};

export default function useSEO({ title, description, image, url } = {}) {
  useEffect(() => {
    const fullTitle = title || defaults.title;
    const fullDesc = description || defaults.description;
    const fullImage = image || defaults.image;

    document.title = fullTitle;

    const setMeta = (name, content, property) => {
      const attr = property ? 'property' : 'name';
      const attrVal = property || name;
      let el = document.querySelector(`meta[${attr}="${attrVal}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, attrVal);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', fullDesc);

    // Open Graph / Facebook
    setMeta('og:title', fullTitle, true);
    setMeta('og:description', fullDesc, true);
    setMeta('og:type', 'website', true);
    setMeta('og:site_name', SITE_NAME, true);
    setMeta('og:image', fullImage, true);
    if (url) setMeta('og:url', url, true);

    // Twitter
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', fullDesc);
    setMeta('twitter:image', fullImage);

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    if (url) canonical.setAttribute('href', url);

  }, [title, description, image, url]);
}
